/* eslint-disable react/jsx-pascal-case */
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import theme, { Content_Text } from "../Component/theme";

import ic_platform_SSMS_1 from "../image/Platform_SSMS/ic_platform_1.png";
import ic_platform_SSMS_10 from "../image/Platform_SSMS/ic_platform_10.png";
import ic_platform_SSMS_10_sel from "../image/Platform_SSMS/ic_platform_10_sel.png";
import ic_platform_SSMS_11 from "../image/Platform_SSMS/ic_platform_11.png";
import ic_platform_SSMS_11_sel from "../image/Platform_SSMS/ic_platform_11_sel.png";
import ic_platform_SSMS_1_sel from "../image/Platform_SSMS/ic_platform_1_sel.png";
import ic_platform_SSMS_2 from "../image/Platform_SSMS/ic_platform_2.png";
import ic_platform_SSMS_2_sel from "../image/Platform_SSMS/ic_platform_2_sel.png";
import ic_platform_SSMS_3 from "../image/Platform_SSMS/ic_platform_3.png";
import ic_platform_SSMS_3_sel from "../image/Platform_SSMS/ic_platform_3_sel.png";
import ic_platform_SSMS_4 from "../image/Platform_SSMS/ic_platform_4.png";
import ic_platform_SSMS_4_sel from "../image/Platform_SSMS/ic_platform_4_sel.png";
import ic_platform_SSMS_5 from "../image/Platform_SSMS/ic_platform_5.png";
import ic_platform_SSMS_5_sel from "../image/Platform_SSMS/ic_platform_5_sel.png";
import ic_platform_SSMS_6 from "../image/Platform_SSMS/ic_platform_6.png";
import ic_platform_SSMS_6_sel from "../image/Platform_SSMS/ic_platform_6_sel.png";
import ic_platform_SSMS_7 from "../image/Platform_SSMS/ic_platform_7.png";
import ic_platform_SSMS_7_sel from "../image/Platform_SSMS/ic_platform_7_sel.png";
import ic_platform_SSMS_8 from "../image/Platform_SSMS/ic_platform_8.png";
import ic_platform_SSMS_8_sel from "../image/Platform_SSMS/ic_platform_8_sel.png";
import ic_platform_SSMS_9 from "../image/Platform_SSMS/ic_platform_9.png";
import ic_platform_SSMS_9_sel from "../image/Platform_SSMS/ic_platform_9_sel.png";

import img_page1_1 from "../image/Platform_SSMS/1_통합현황판_1.png";
import img_page1_2 from "../image/Platform_SSMS/1_통합현황판_2.png";
import img_page1_3 from "../image/Platform_SSMS/1_통합현황판_3.png";
import img_page2_1 from "../image/Platform_SSMS/2_결재관리_1.png";
import img_page2_2 from "../image/Platform_SSMS/2_결재관리_2.png";
import img_page3 from "../image/Platform_SSMS/3_안전보건예산.png";
import img_page4_1 from "../image/Platform_SSMS/4_점검_1.png";
import img_page4_2 from "../image/Platform_SSMS/4_점검_2.png";
import img_page4_3 from "../image/Platform_SSMS/4_점검_3.png";
import img_page4_4 from "../image/Platform_SSMS/4_점검_4.png";
import img_page5_1 from "../image/Platform_SSMS/5_교육_1.png";
import img_page5_2 from "../image/Platform_SSMS/5_교육_2.png";
import img_page5_3 from "../image/Platform_SSMS/5_교육_3.png";
import img_page5_4 from "../image/Platform_SSMS/5_교육_4.png";
import img_page5_5 from "../image/Platform_SSMS/5_교육_5.png";
import img_page5_6 from "../image/Platform_SSMS/5_교육_6.png";
import img_page6_1 from "../image/Platform_SSMS/6_TBM_1.png";
import img_page6_2 from "../image/Platform_SSMS/6_TBM_2.png";
import img_page6_3 from "../image/Platform_SSMS/6_TBM_3.png";
import img_page6_4 from "../image/Platform_SSMS/6_TBM_4.png";
import img_page6_5 from "../image/Platform_SSMS/6_TBM_5.png";
import img_page6_6 from "../image/Platform_SSMS/6_TBM_6.png";
import img_page7_1 from "../image/Platform_SSMS/7_MBDS_1.png";
import img_page7_2 from "../image/Platform_SSMS/7_MBDS_2.png";
import img_page7_3 from "../image/Platform_SSMS/7_MBDS_3.png";
import img_page8_1 from "../image/Platform_SSMS/8_사고조사표_1.png";
import img_page8_2 from "../image/Platform_SSMS/8_사고조사표_2.png";
import img_page8_3 from "../image/Platform_SSMS/8_사고조사표_3.png";
import img_page8_4 from "../image/Platform_SSMS/8_사고조사표_4.png";
import img_page9_1 from "../image/Platform_SSMS/9_위험성평가_1.png";
import img_page9_2 from "../image/Platform_SSMS/9_위험성평가_2.png";
import img_page9_3 from "../image/Platform_SSMS/9_위험성평가_3.png";
import img_page9_4 from "../image/Platform_SSMS/9_위험성평가_4.png";
import img_page9_5 from "../image/Platform_SSMS/9_위험성평가_5.png";
import img_page9_6 from "../image/Platform_SSMS/9_위험성평가_6.png";
import img_page9_7 from "../image/Platform_SSMS/9_위험성평가_7.png";
import img_page10_1 from "../image/Platform_SSMS/10_직원관리.png";
import img_page11_1 from "../image/Platform_SSMS/11_AI챗봇_1.png";
import img_page11_2 from "../image/Platform_SSMS/11_AI챗봇_2.png";

const Main_div = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  padding-bottom: 40px;
  @media (max-width: 800px) {
    padding-bottom: 29px;
  }
`;

const Main_Content4 = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;

  @media (max-width: 800px) {
    padding: 0px 15px 0px 15px;
  }
`;

const Main_Content5 = styled.div`
  width: 50%;
  display: flex;
  justify-content: space-between;

  @media (max-width: 800px) {
    padding: 0px 15px 0px 15px;
  }
`;

const Select_div = styled.div`
  display: flex;
  width: 100%;
  max-width: 1100px;
  padding-top: 50px;
  justify-content: center;
  flex-direction: row; /* 기본 방향은 행 */
  @media (max-width: 1200px) {
    padding: 50px 15px 0px 15px;
    max-width: 650px;
  }
  @media (max-width: 800px) {
    padding: 0px;
    max-width: 650px;
  }
`;

const Select_div3 = styled.div`
  display: flex;
  width: 100%;
  max-width: 1100px;
  padding-top: 50px;
  justify-content: center;
  flex-direction: row; /* 기본 방향은 행 */
  @media (max-width: 1200px) {
    padding: 0px 15px 0px 15px;
    max-width: 650px;
  }
`;

const Btn_Div = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  text-align: center;
  @media (max-width: 800px) {
    flex: 0;
  }
`;

const Main_Bar = styled.div`
  border-width: 2px 0px 0px 0px;
  border-color: ${theme.colors.bgGray};
  border-style: solid;
  width: 1200px;
  margin-bottom: 10px;
  @media (max-width: 800px) {
    width: 100%;
  }
`;

const Title_div = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  margin-bottom: 5px;
`;
const Image_div2 = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
`;
const Text_div2 = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 800px;
  align-self: center;
  justify-content: center;
  text-align: left;
  margin-bottom: 100px;
  @media (max-width: 800px) {
    width: 80%;
  }
`;

const Info_Text = styled(Content_Text)`
  margin-top: 8px;
`;

const Image3 = styled.img`
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  width: ${(props) => (props.$large ? "900px" : "800px")};
  margin-bottom: 30px;
  margin-left: ${(props) => (props.$large ? "100px" : 0)};
  border-radius: 8px;

  @media (max-width: 800px) {
    width: ${(props) => (props.$large ? "90%" : "80%")};
    margin-left: ${(props) => (props.$large ? "10%" : 0)};
  }
`;

const Image2 = styled.img`
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  width: 60px;
  cursor: pointer;
`;

const Platform_SSMS_표준형 = () => {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  const [sel, set_Sel] = useState("01");

  useEffect(() => {
    // 사이즈 체크
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {windowSize.width > 1200 ? (
        <Main_div>
          <Select_div>
            <Main_Content4>
              <Btn_Div>
                <Image2
                  onClick={() => {
                    set_Sel("01");
                  }}
                  src={
                    sel === "01" ? ic_platform_SSMS_1_sel : ic_platform_SSMS_1
                  }
                  alt={ic_platform_SSMS_1}
                />
                <Content_Text
                  style={{ marginTop: 10 }}
                  $blue2={sel === "01"}
                  $lightGray
                  $small
                  $bold
                >
                  통합현황판
                </Content_Text>
              </Btn_Div>
              <Btn_Div>
                <Image2
                  onClick={() => {
                    set_Sel("02");
                  }}
                  src={
                    sel === "02" ? ic_platform_SSMS_2_sel : ic_platform_SSMS_2
                  }
                  alt={ic_platform_SSMS_2}
                />
                <Content_Text
                  style={{ marginTop: 10 }}
                  $blue2={sel === "02"}
                  $lightGray
                  $small
                  $bold
                >
                  결재 관리
                </Content_Text>
              </Btn_Div>
              <Btn_Div>
                <Image2
                  onClick={() => {
                    set_Sel("03");
                  }}
                  src={
                    sel === "03" ? ic_platform_SSMS_3_sel : ic_platform_SSMS_3
                  }
                  alt={ic_platform_SSMS_3}
                />
                <Content_Text
                  style={{ marginTop: 10 }}
                  $blue2={sel === "03"}
                  $lightGray
                  $small
                  $bold
                >
                  안전보건예산
                </Content_Text>
              </Btn_Div>
              <Btn_Div>
                <Image2
                  onClick={() => {
                    set_Sel("04");
                  }}
                  src={
                    sel === "04" ? ic_platform_SSMS_4_sel : ic_platform_SSMS_4
                  }
                  alt={ic_platform_SSMS_4}
                />
                <Content_Text
                  style={{ marginTop: 10 }}
                  $blue2={sel === "04"}
                  $lightGray
                  $small
                  $bold
                >
                  점검
                </Content_Text>
              </Btn_Div>
              <Btn_Div>
                <Image2
                  onClick={() => {
                    set_Sel("05");
                  }}
                  src={
                    sel === "05" ? ic_platform_SSMS_5_sel : ic_platform_SSMS_5
                  }
                  alt={ic_platform_SSMS_5}
                />
                <Content_Text
                  style={{ marginTop: 10 }}
                  $blue2={sel === "05"}
                  $lightGray
                  $small
                  $bold
                >
                  교육
                </Content_Text>
              </Btn_Div>
              <Btn_Div>
                <Image2
                  onClick={() => {
                    set_Sel("06");
                  }}
                  src={
                    sel === "06" ? ic_platform_SSMS_6_sel : ic_platform_SSMS_6
                  }
                  alt={ic_platform_SSMS_6}
                />
                <Content_Text
                  style={{ marginTop: 10 }}
                  $blue2={sel === "06"}
                  $lightGray
                  $small
                  $bold
                >
                  TBM
                </Content_Text>
              </Btn_Div>

              <Btn_Div>
                <Image2
                  onClick={() => {
                    set_Sel("07");
                  }}
                  src={
                    sel === "07" ? ic_platform_SSMS_7_sel : ic_platform_SSMS_7
                  }
                  alt={ic_platform_SSMS_7}
                />
                <Content_Text
                  style={{ marginTop: 10 }}
                  $blue2={sel === "07"}
                  $lightGray
                  $small
                  $bold
                >
                  MSDS
                </Content_Text>
              </Btn_Div>

              <Btn_Div>
                <Image2
                  onClick={() => {
                    set_Sel("08");
                  }}
                  src={
                    sel === "08" ? ic_platform_SSMS_8_sel : ic_platform_SSMS_8
                  }
                  alt={ic_platform_SSMS_8}
                />
                <Content_Text
                  style={{ marginTop: 10 }}
                  $blue2={sel === "08"}
                  $lightGray
                  $small
                  $bold
                >
                  사고조사표
                </Content_Text>
              </Btn_Div>

              <Btn_Div>
                <Image2
                  onClick={() => {
                    set_Sel("09");
                  }}
                  src={
                    sel === "09" ? ic_platform_SSMS_9_sel : ic_platform_SSMS_9
                  }
                  alt={ic_platform_SSMS_9}
                />
                <Content_Text
                  style={{ marginTop: 10 }}
                  $blue2={sel === "09"}
                  $lightGray
                  $small
                  $bold
                >
                  위험성평가
                </Content_Text>
              </Btn_Div>

              <Btn_Div>
                <Image2
                  onClick={() => {
                    set_Sel("10");
                  }}
                  src={
                    sel === "10" ? ic_platform_SSMS_10_sel : ic_platform_SSMS_10
                  }
                  alt={ic_platform_SSMS_10}
                />
                <Content_Text
                  style={{ marginTop: 10 }}
                  $blue2={sel === "10"}
                  $lightGray
                  $small
                  $bold
                >
                  직원 관리
                </Content_Text>
              </Btn_Div>
              <Btn_Div>
                <Image2
                  onClick={() => {
                    set_Sel("11");
                  }}
                  src={
                    sel === "11" ? ic_platform_SSMS_11_sel : ic_platform_SSMS_11
                  }
                  alt={ic_platform_SSMS_11}
                />
                <Content_Text
                  style={{ marginTop: 10 }}
                  $blue2={sel === "11"}
                  $lightGray
                  $small
                  $bold
                >
                  AI 챗봇
                </Content_Text>
              </Btn_Div>
            </Main_Content4>
          </Select_div>
        </Main_div>
      ) : windowSize.width > 800 ? (
        <>
          <Main_div>
            <Select_div>
              <Main_Content4>
                <Btn_Div>
                  <Image2
                    onClick={() => {
                      set_Sel("01");
                    }}
                    src={
                      sel === "01" ? ic_platform_SSMS_1_sel : ic_platform_SSMS_1
                    }
                    alt={ic_platform_SSMS_1}
                  />
                  <Content_Text
                    style={{ marginTop: 10 }}
                    $blue2={sel === "01"}
                    $lightGray
                    $small
                    $bold
                  >
                    통합현황판
                  </Content_Text>
                </Btn_Div>
                <Btn_Div>
                  <Image2
                    onClick={() => {
                      set_Sel("02");
                    }}
                    src={
                      sel === "02" ? ic_platform_SSMS_2_sel : ic_platform_SSMS_2
                    }
                    alt={ic_platform_SSMS_2}
                  />
                  <Content_Text
                    style={{ marginTop: 10 }}
                    $blue2={sel === "02"}
                    $lightGray
                    $small
                    $bold
                  >
                    결재 관리
                  </Content_Text>
                </Btn_Div>
                <Btn_Div>
                  <Image2
                    onClick={() => {
                      set_Sel("03");
                    }}
                    src={
                      sel === "03" ? ic_platform_SSMS_3_sel : ic_platform_SSMS_3
                    }
                    alt={ic_platform_SSMS_3}
                  />
                  <Content_Text
                    style={{ marginTop: 10 }}
                    $blue2={sel === "03"}
                    $lightGray
                    $small
                    $bold
                  >
                    안전보건예산
                  </Content_Text>
                </Btn_Div>
                <Btn_Div>
                  <Image2
                    onClick={() => {
                      set_Sel("04");
                    }}
                    src={
                      sel === "04" ? ic_platform_SSMS_4_sel : ic_platform_SSMS_4
                    }
                    alt={ic_platform_SSMS_4}
                  />
                  <Content_Text
                    style={{ marginTop: 10 }}
                    $blue2={sel === "04"}
                    $lightGray
                    $small
                    $bold
                  >
                    점검
                  </Content_Text>
                </Btn_Div>
                <Btn_Div>
                  <Image2
                    onClick={() => {
                      set_Sel("05");
                    }}
                    src={
                      sel === "05" ? ic_platform_SSMS_5_sel : ic_platform_SSMS_5
                    }
                    alt={ic_platform_SSMS_5}
                  />
                  <Content_Text
                    style={{ marginTop: 10 }}
                    $blue2={sel === "05"}
                    $lightGray
                    $small
                    $bold
                  >
                    교육
                  </Content_Text>
                </Btn_Div>
                <Btn_Div>
                  <Image2
                    onClick={() => {
                      set_Sel("06");
                    }}
                    src={
                      sel === "06" ? ic_platform_SSMS_6_sel : ic_platform_SSMS_6
                    }
                    alt={ic_platform_SSMS_6}
                  />
                  <Content_Text
                    style={{ marginTop: 10 }}
                    $blue2={sel === "06"}
                    $lightGray
                    $small
                    $bold
                  >
                    TBM
                  </Content_Text>
                </Btn_Div>
              </Main_Content4>
            </Select_div>
          </Main_div>
          <Main_div>
            <Select_div3>
              <Main_Content4>
                <Btn_Div>
                  <Image2
                    onClick={() => {
                      set_Sel("07");
                    }}
                    src={
                      sel === "07" ? ic_platform_SSMS_7_sel : ic_platform_SSMS_7
                    }
                    alt={ic_platform_SSMS_7}
                  />
                  <Content_Text
                    style={{ marginTop: 10 }}
                    $blue2={sel === "07"}
                    $lightGray
                    $small
                    $bold
                  >
                    MSDS
                  </Content_Text>
                </Btn_Div>

                <Btn_Div>
                  <Image2
                    onClick={() => {
                      set_Sel("08");
                    }}
                    src={
                      sel === "08" ? ic_platform_SSMS_8_sel : ic_platform_SSMS_8
                    }
                    alt={ic_platform_SSMS_8}
                  />
                  <Content_Text
                    style={{ marginTop: 10 }}
                    $blue2={sel === "08"}
                    $lightGray
                    $small
                    $bold
                  >
                    사고조사표
                  </Content_Text>
                </Btn_Div>

                <Btn_Div>
                  <Image2
                    onClick={() => {
                      set_Sel("09");
                    }}
                    src={
                      sel === "09" ? ic_platform_SSMS_9_sel : ic_platform_SSMS_9
                    }
                    alt={ic_platform_SSMS_9}
                  />
                  <Content_Text
                    style={{ marginTop: 10 }}
                    $blue2={sel === "09"}
                    $lightGray
                    $small
                    $bold
                  >
                    위험성평가
                  </Content_Text>
                </Btn_Div>

                <Btn_Div>
                  <Image2
                    onClick={() => {
                      set_Sel("10");
                    }}
                    src={
                      sel === "10"
                        ? ic_platform_SSMS_10_sel
                        : ic_platform_SSMS_10
                    }
                    alt={ic_platform_SSMS_10}
                  />
                  <Content_Text
                    style={{ marginTop: 10 }}
                    $blue2={sel === "10"}
                    $lightGray
                    $small
                    $bold
                  >
                    직원 관리
                  </Content_Text>
                </Btn_Div>
                <Btn_Div>
                  <Image2
                    onClick={() => {
                      set_Sel("11");
                    }}
                    src={
                      sel === "11"
                        ? ic_platform_SSMS_11_sel
                        : ic_platform_SSMS_11
                    }
                    alt={ic_platform_SSMS_11}
                  />
                  <Content_Text
                    style={{ marginTop: 10 }}
                    $blue2={sel === "11"}
                    $lightGray
                    $small
                    $bold
                  >
                    AI 챗봇
                  </Content_Text>
                </Btn_Div>
              </Main_Content4>
            </Select_div3>
          </Main_div>
        </>
      ) : (
        <>
          <Main_div>
            <Select_div>
              <Main_Content4>
                <Btn_Div>
                  <Image2
                    onClick={() => {
                      set_Sel("01");
                    }}
                    src={
                      sel === "01" ? ic_platform_SSMS_1_sel : ic_platform_SSMS_1
                    }
                    alt={ic_platform_SSMS_1}
                  />
                  <Content_Text
                    style={{ marginTop: 10 }}
                    $blue2={sel === "01"}
                    $lightGray
                    $small
                    $bold
                  >
                    통합현황판
                  </Content_Text>
                </Btn_Div>
                <Btn_Div>
                  <Image2
                    onClick={() => {
                      set_Sel("02");
                    }}
                    src={
                      sel === "02" ? ic_platform_SSMS_2_sel : ic_platform_SSMS_2
                    }
                    alt={ic_platform_SSMS_2}
                  />
                  <Content_Text
                    style={{ marginTop: 10 }}
                    $blue2={sel === "02"}
                    $lightGray
                    $small
                    $bold
                  >
                    결재 관리
                  </Content_Text>
                </Btn_Div>
                <Btn_Div>
                  <Image2
                    onClick={() => {
                      set_Sel("03");
                    }}
                    src={
                      sel === "03" ? ic_platform_SSMS_3_sel : ic_platform_SSMS_3
                    }
                    alt={ic_platform_SSMS_3}
                  />
                  <Content_Text
                    style={{ marginTop: 10 }}
                    $blue2={sel === "03"}
                    $lightGray
                    $small
                    $bold
                  >
                    안전보건예산
                  </Content_Text>
                </Btn_Div>
                <Btn_Div>
                  <Image2
                    onClick={() => {
                      set_Sel("04");
                    }}
                    src={
                      sel === "04" ? ic_platform_SSMS_4_sel : ic_platform_SSMS_4
                    }
                    alt={ic_platform_SSMS_4}
                  />
                  <Content_Text
                    style={{ marginTop: 10 }}
                    $blue2={sel === "04"}
                    $lightGray
                    $small
                    $bold
                  >
                    점검
                  </Content_Text>
                </Btn_Div>
                <Btn_Div>
                  <Image2
                    onClick={() => {
                      set_Sel("05");
                    }}
                    src={
                      sel === "05" ? ic_platform_SSMS_5_sel : ic_platform_SSMS_5
                    }
                    alt={ic_platform_SSMS_5}
                  />
                  <Content_Text
                    style={{ marginTop: 10 }}
                    $blue2={sel === "05"}
                    $lightGray
                    $small
                    $bold
                  >
                    교육
                  </Content_Text>
                </Btn_Div>
              </Main_Content4>
            </Select_div>
          </Main_div>
          <Main_div>
            <Select_div>
              <Main_Content4>
                <Btn_Div>
                  <Image2
                    onClick={() => {
                      set_Sel("06");
                    }}
                    src={
                      sel === "06" ? ic_platform_SSMS_6_sel : ic_platform_SSMS_6
                    }
                    alt={ic_platform_SSMS_6}
                  />
                  <Content_Text
                    style={{ marginTop: 10 }}
                    $blue2={sel === "06"}
                    $lightGray
                    $small
                    $bold
                  >
                    TBM
                  </Content_Text>
                </Btn_Div>

                <Btn_Div>
                  <Image2
                    onClick={() => {
                      set_Sel("07");
                    }}
                    src={
                      sel === "07" ? ic_platform_SSMS_7_sel : ic_platform_SSMS_7
                    }
                    alt={ic_platform_SSMS_7}
                  />
                  <Content_Text
                    style={{ marginTop: 10 }}
                    $blue2={sel === "07"}
                    $lightGray
                    $small
                    $bold
                  >
                    MSDS
                  </Content_Text>
                </Btn_Div>

                <Btn_Div>
                  <Image2
                    onClick={() => {
                      set_Sel("08");
                    }}
                    src={
                      sel === "08" ? ic_platform_SSMS_8_sel : ic_platform_SSMS_8
                    }
                    alt={ic_platform_SSMS_8}
                  />
                  <Content_Text
                    style={{ marginTop: 10 }}
                    $blue2={sel === "08"}
                    $lightGray
                    $small
                    $bold
                  >
                    사고조사표
                  </Content_Text>
                </Btn_Div>

                <Btn_Div>
                  <Image2
                    onClick={() => {
                      set_Sel("09");
                    }}
                    src={
                      sel === "09" ? ic_platform_SSMS_9_sel : ic_platform_SSMS_9
                    }
                    alt={ic_platform_SSMS_9}
                  />
                  <Content_Text
                    style={{ marginTop: 10 }}
                    $blue2={sel === "09"}
                    $lightGray
                    $small
                    $bold
                  >
                    위험성평가
                  </Content_Text>
                </Btn_Div>

                <Btn_Div>
                  <Image2
                    onClick={() => {
                      set_Sel("10");
                    }}
                    src={
                      sel === "10"
                        ? ic_platform_SSMS_10_sel
                        : ic_platform_SSMS_10
                    }
                    alt={ic_platform_SSMS_10}
                  />
                  <Content_Text
                    style={{ marginTop: 10 }}
                    $blue2={sel === "10"}
                    $lightGray
                    $small
                    $bold
                  >
                    직원 관리
                  </Content_Text>
                </Btn_Div>
              </Main_Content4>
            </Select_div>
          </Main_div>
          <Main_div>
            <Select_div>
              <Main_Content5 style={{ justifyContent: "space-between" }}>
                <Btn_Div>
                  <Image2
                    onClick={() => {
                      set_Sel("11");
                    }}
                    src={
                      sel === "11"
                        ? ic_platform_SSMS_11_sel
                        : ic_platform_SSMS_11
                    }
                    alt={ic_platform_SSMS_11}
                  />
                  <Content_Text
                    style={{ marginTop: 10 }}
                    $blue2={sel === "11"}
                    $lightGray
                    $small
                    $bold
                  >
                    AI 챗봇
                  </Content_Text>
                </Btn_Div>
              </Main_Content5>
            </Select_div>
          </Main_div>
        </>
      )}
      <Main_div>
        <Main_Bar></Main_Bar>
      </Main_div>
      <Title_div>
        <Content_Text $bold $blue2>
          {sel}
        </Content_Text>
      </Title_div>
      <Title_div style={{ marginBottom: 30 }}>
        <Content_Text $xlarge $xbold>
          {sel === "01"
            ? "통합현황판"
            : sel === "02"
            ? "결재 관리"
            : sel === "03"
            ? "안전보건예산"
            : sel === "04"
            ? "점검"
            : sel === "05"
            ? "교육"
            : sel === "06"
            ? "TBM"
            : sel === "07"
            ? "MSDS"
            : sel === "08"
            ? "사고조사표"
            : sel === "09"
            ? "위험성평가"
            : sel === "10"
            ? "직원 관리"
            : sel === "11"
            ? "AI 챗봇"
            : "직원관리"}
        </Content_Text>
      </Title_div>
      {sel === "01" ? (
        <>
          <Image_div2>
            <Image3 src={img_page1_1} alt={img_page1_1} />
          </Image_div2>
          <Text_div2>
            <Content_Text $large $bold>
              최상위관리자(주관사)
            </Content_Text>
            <Info_Text $gray>
              1) 월별로 각 부서의 안전점검에 대한 실적 현황을 확인할 수
              있습니다.
            </Info_Text>
            <Info_Text $gray>
              2) 부서별로 점검에 대한 개선률을 확인할 수 있습니다.
            </Info_Text>
            <Info_Text $gray>
              3) 부서별로 안전사고 발생 현황 및 안전사고 발생 추이, 유형별
              안전사고 현황을 확인할 수 있습니다.
            </Info_Text>
            <Info_Text $gray>
              4) 부서별 교육 현황을 확인할 수 있습니다.
            </Info_Text>
            <Info_Text $gray>
              5) 부서별 위험성 평가 현황을 확인할 수 있습니다.
            </Info_Text>
          </Text_div2>
          <Image_div2>
            <Image3 src={img_page1_2} alt={img_page1_2} />
          </Image_div2>
          <Text_div2>
            <Content_Text $large $bold>
              상위관리자(각 부서 팀장)
            </Content_Text>
            <Info_Text $gray>
              1) 점검,교육,TBM,위험서평가의 결재가 필요한 부분을 확인할 수
              있습니다.
            </Info_Text>
            <Info_Text $gray>
              2) 최상위관리자로부터 지시를 받은 점검을 확인할 수 있습니다.
            </Info_Text>
            <Info_Text $gray>
              3) 최상위관리자로부터 지시를 받은 교육을 확인할 수 있습니다.
            </Info_Text>
            <Info_Text $gray>4) TBM 진행사항을 확인할 수 있습니다.</Info_Text>
            <Info_Text $gray>5) 사고 현황에 대해 확인할 수 있습니다.</Info_Text>
            <Info_Text $gray>
              6) 위험성평가 진행사항을 확인할 수 있습니다.
            </Info_Text>
          </Text_div2>
          <Image_div2>
            <Image3 src={img_page1_3} alt={img_page1_3} />
          </Image_div2>
          <Text_div2>
            <Content_Text $large $bold>
              일반관리자
            </Content_Text>
            <Info_Text $gray>
              1) 점검,교육,TBM,위험서평가의 결재가 필요한 부분을 확인할 수
              있습니다.
            </Info_Text>
            <Info_Text $gray>
              2) 최상위관리자로부터 지시를 받은 점검을 확인할 수 있습니다.
            </Info_Text>
            <Info_Text $gray>
              3) 최상위관리자로부터 지시를 받은 교육을 확인할 수 있습니다.
            </Info_Text>
            <Info_Text $gray>4) TBM 진행사항을 확인할 수 있습니다.</Info_Text>
            <Info_Text $gray>5) 사고 현황에 대해 확인할 수 있습니다.</Info_Text>
            <Info_Text $gray>
              6) 위험성평가 진행사항을 확인할 수 있습니다.
            </Info_Text>
          </Text_div2>
        </>
      ) : sel === "02" ? (
        <>
          <Image_div2>
            <Image3 src={img_page2_1} alt={img_page2_1} />
          </Image_div2>
          <Text_div2>
            <Info_Text $large $bold>
              상위관리자(각 부서 팀장)
            </Info_Text>
            <Info_Text $gray>
              1) 일반관리자 및 직원들이 진행한 점검,교육,TBM,위험성평가에 대해
              결재 요청사항을 통합으로 확인할 수 있습니다.
            </Info_Text>
          </Text_div2>
          <Image_div2>
            <Image3 src={img_page2_2} alt={img_page2_2} />
          </Image_div2>
          <Text_div2>
            <Info_Text $large $bold>
              일반관리자
            </Info_Text>
            <Info_Text $gray>
              1) 점검,교육,위험성평가에 대한 결재 요청사항을 통합으로 확인할 수
              있습니다.
            </Info_Text>
          </Text_div2>
        </>
      ) : sel === "03" ? (
        <>
          <Image_div2>
            <Image3 src={img_page3} alt={img_page3} />
          </Image_div2>
          <Text_div2>
            <Info_Text $large $bold>
              관리자
            </Info_Text>
            <Info_Text $gray>
              1) 한 해의 예산을 계획하고 이에 맞춰 집행내역을 작성할 수
              있습니다.
            </Info_Text>
          </Text_div2>
        </>
      ) : sel === "04" ? (
        <>
          <Image_div2>
            <Image3 src={img_page4_1} alt={img_page4_1} />
          </Image_div2>
          <Text_div2>
            <Info_Text $large $bold>
              최상위관리자(주관사)
            </Info_Text>
            <Info_Text $gray>
              1) 월별로 각 부서의 안전점검에 대한 실적과 개선률을 확인하고 점검
              지시를 할 수 있습니다.
            </Info_Text>
          </Text_div2>
          <Image_div2>
            <Image3 src={img_page4_2} alt={img_page4_2} />
          </Image_div2>
          <Text_div2>
            <Info_Text $large $bold>
              상위관리자(각 부서 팀장)
            </Info_Text>
            <Info_Text $gray>
              1) 최상위관리자로부터 요청받은 점검을 확인할 수 있으며,
              일반관리자가 처리 후 결재 요청한 점검에 대해 결재승인을 할 수
              있습니다.
            </Info_Text>
          </Text_div2>
          <Image_div2>
            <Image3 src={img_page4_3} alt={img_page4_3} />
          </Image_div2>
          <Image_div2>
            <Image3 src={img_page4_4} alt={img_page4_4} />
          </Image_div2>
          <Text_div2>
            <Info_Text $large $bold>
              일반관리자
            </Info_Text>
            <Info_Text $gray>
              1) 최상위관리자로부터 요청받은 점검을 확인하고, 지적받은 사항을
              개선 조치할 수 있습니다.
            </Info_Text>
          </Text_div2>
        </>
      ) : sel === "05" ? (
        <>
          <Image_div2>
            <Image3 src={img_page5_1} alt={img_page5_1} />
          </Image_div2>
          <Image_div2>
            <Image3 src={img_page5_2} alt={img_page5_2} />
          </Image_div2>
          <Text_div2>
            <Info_Text $large $bold>
              최상위관리자(주관사)
            </Info_Text>
            <Info_Text $gray>
              1) 각 부서에게 교육을 지시하고 교육 현황을 확인할 수 있습니다.
              교육 이수현황에 따라 월별 교육 실적 현황이 업데이트되며 부서별
              실적을 한 눈에 확인할 수 있습니다.
            </Info_Text>
          </Text_div2>
          <Image_div2>
            <Image3 src={img_page5_3} alt={img_page5_3} />
          </Image_div2>
          <Text_div2>
            <Info_Text $large $bold>
              상위관리자(각 부서 팀장)
            </Info_Text>
            <Info_Text $gray>
              1) 최상위관리자로부터 지시받은 교육을 확인할 수 있으며, 교육현황
              및 개인 이수현황을 조회할 수 있습니다.
            </Info_Text>
          </Text_div2>
          <Image_div2>
            <Image3 src={img_page5_4} alt={img_page5_4} />
          </Image_div2>
          <Text_div2>
            <Info_Text $large $bold>
              일반관리자
            </Info_Text>
            <Info_Text $gray>
              1) 최상위관리자로부터 지시받은 교육을 확인할 수 있으며, 전체적인
              교육 현황을 관리하며 조회할 수 있습니다.
            </Info_Text>
          </Text_div2>
          <Image_div2>
            <Image3 src={img_page5_5} alt={img_page5_5} />
          </Image_div2>
          <Image_div2>
            <Image3 src={img_page5_6} alt={img_page5_6} />
          </Image_div2>
          <Text_div2>
            <Info_Text $large $bold>
              일반직원(교육대상자)
            </Info_Text>
            <Info_Text $gray>
              1) PC와 모바일에서 등록된 교육일정을 확인하고 이수할 수 있습니다.
            </Info_Text>
          </Text_div2>
        </>
      ) : sel === "06" ? (
        <>
          <Image_div2>
            <Image3 src={img_page6_1} alt={img_page6_1} />
          </Image_div2>
          <Image_div2>
            <Image3 src={img_page6_2} alt={img_page6_2} />
          </Image_div2>
          <Text_div2>
            <Info_Text $large $bold>
              최상위관리자(주관사)
            </Info_Text>
            <Info_Text $gray>
              1) 진행되는 TBM회의를 조회할 수 있으며, 월별 TBM 실적을 부서별로
              조회할 수 있습니다.
            </Info_Text>
          </Text_div2>
          <Image_div2>
            <Image3 src={img_page6_3} alt={img_page6_3} />
          </Image_div2>
          <Text_div2>
            <Info_Text $large $bold>
              상위관리자(각 부서 팀장)
            </Info_Text>
            <Info_Text $gray>
              1) 조별로 진행되는 TBM 회의를 조회하고 요청되는 결재사항을 처리할
              수 있습니다.
            </Info_Text>
          </Text_div2>
          <Image_div2>
            <Image3 src={img_page6_4} alt={img_page6_4} />
          </Image_div2>
          <Text_div2>
            <Info_Text $large $bold>
              일반관리자
            </Info_Text>
            <Info_Text $gray>
              1) 조별로 진행되는 TBM 회의를 조회할 수 있습니다.
            </Info_Text>
          </Text_div2>
          <Image_div2>
            <Image3 src={img_page6_5} alt={img_page6_5} />
          </Image_div2>
          <Image_div2>
            <Image3 src={img_page6_6} alt={img_page6_6} />
          </Image_div2>
          <Text_div2>
            <Info_Text $large $bold>
              일반직원(TBM 회의 진행,참여)
            </Info_Text>
            <Info_Text $gray>
              1) PC와 모바일을 통해 TBM회의를 진행하고 참여자에 대한 서명을 받을
              수 있습니다.
            </Info_Text>
          </Text_div2>
        </>
      ) : sel === "07" ? (
        <>
          <Image_div2>
            <Image3 src={img_page7_1} alt={img_page7_1} />
          </Image_div2>
          <Text_div2>
            <Info_Text $large $bold>
              상위관리자(각 부서 팀장)
            </Info_Text>
            <Info_Text $gray>
              1) 일반관리자가 관리하는 MSDS 관리대장을 조회할 수 있습니다.
            </Info_Text>
          </Text_div2>
          <Image_div2>
            <Image3 src={img_page7_2} alt={img_page7_2} />
          </Image_div2>
          <Image_div2>
            <Image3 src={img_page7_3} alt={img_page7_3} />
          </Image_div2>
          <Text_div2>
            <Info_Text $large $bold>
              일반관리자
            </Info_Text>
            <Info_Text $gray>
              1) 화학제품 및 유해물질에 대해 등록하고 관리할 수 있습니다.
            </Info_Text>
          </Text_div2>
        </>
      ) : sel === "08" ? (
        <>
          <Image_div2>
            <Image3 src={img_page8_1} alt={img_page8_1} />
          </Image_div2>
          <Text_div2>
            <Info_Text $large $bold>
              최상위관리자(주관사)
            </Info_Text>
            <Info_Text $gray>
              1) 3개년의 부서별 안전사고 발생 현황,안전사고 발생 추이,유형별
              안전사고 현황을 조회할 수 있습니다.
            </Info_Text>
          </Text_div2>
          <Image_div2>
            <Image3 src={img_page8_2} alt={img_page8_2} />
          </Image_div2>
          <Text_div2>
            <Info_Text $large $bold>
              상위관리자(각 부서 팀장)
            </Info_Text>
            <Info_Text $gray>
              1) 일반관리자가 등록한 안전사고에 대해 조회할 수 있습니다.
            </Info_Text>
          </Text_div2>
          <Image_div2>
            <Image3 src={img_page8_3} alt={img_page8_3} />
          </Image_div2>
          <Image_div2>
            <Image3 src={img_page8_4} alt={img_page8_4} />
          </Image_div2>
          <Text_div2>
            <Info_Text $large $bold>
              일반관리자
            </Info_Text>
            <Info_Text $gray>
              1) 안전사고에 대한 자료 및 정보를 등록하고 관리할 수 있습니다.
            </Info_Text>
          </Text_div2>
        </>
      ) : sel === "09" ? (
        <>
          <Image_div2>
            <Image3 src={img_page9_1} alt={img_page9_1} />
          </Image_div2>
          <Text_div2>
            <Info_Text $large $bold>
              최상위관리자(주관사)
            </Info_Text>
            <Info_Text $gray>
              1) 각 부서별 진행되는 위험성평가를 조회하고, 완료된 위험성평가에
              대해 보완요청을 할 수 있습니다.
            </Info_Text>
          </Text_div2>
          <Image_div2>
            <Image3 src={img_page9_2} alt={img_page9_2} />
          </Image_div2>
          <Text_div2>
            <Info_Text $large $bold>
              상위관리자(각 부서 팀장)
            </Info_Text>
            <Info_Text $gray>
              1) 진행되고있는 위험성평가에 대해 현황을 조회할 수 있으며 요청되는
              결재사항을 처리할 수 있습니다.
            </Info_Text>
          </Text_div2>
          <Image_div2>
            <Image3 src={img_page9_3} alt={img_page9_3} />
          </Image_div2>
          <Image_div2>
            <Image3 src={img_page9_4} alt={img_page9_4} />
          </Image_div2>
          <Text_div2>
            <Info_Text $large $bold>
              일반관리자
            </Info_Text>
            <Info_Text $gray>
              1) 위험성평가를 진행하며 유해·위험요인을 파악 후 안전보건정보와
              위험성평가표를 작성합니다. 전 직원들이 참여하는 조별 회의에 대해
              검토하고 관리할 수 있습니다.
            </Info_Text>
          </Text_div2>
          <Image_div2>
            <Image3 src={img_page9_5} alt={img_page9_5} />
          </Image_div2>
          <Image_div2>
            <Image3 src={img_page9_6} alt={img_page9_6} />
          </Image_div2>
          <Image_div2>
            <Image3 src={img_page9_7} alt={img_page9_7} />
          </Image_div2>
          <Text_div2>
            <Info_Text $large $bold>
              일반직원(조별 회의 진행,참여)
            </Info_Text>
            <Info_Text $gray>
              1) 등록된 위험성평가에 대해 조별 회의를 진행하거나 참여할 수
              있으며, 유해·위험요인을 등록할 수 있습니다.
            </Info_Text>
          </Text_div2>
        </>
      ) : sel === "10" ? (
        <>
          <Image_div2>
            <Image3 src={img_page10_1} alt={img_page10_1} />
          </Image_div2>
          <Text_div2>
            <Info_Text $large $bold>
              최상위관리자(주관사), 상위관리자(각 부서 팀장)
            </Info_Text>
            <Info_Text $gray>
              1) 직원들을 등록하고 부서,직급,입사일,재직 상태 등 직원들의 정보를
              관리할 수 있습니다.
            </Info_Text>
          </Text_div2>
        </>
      ) : sel === "11" ? (
        <>
          <Image_div2>
            <Image3 src={img_page11_1} alt={img_page11_1} />
          </Image_div2>
          <Image_div2>
            <Image3 src={img_page11_2} alt={img_page11_2} />
          </Image_div2>
          <Text_div2>
            <Info_Text $large $bold>
              관리자
            </Info_Text>
            <Info_Text $gray>
              1) 산업안전보건법, 현장관리 매뉴얼 등 방대한 데이터를 기반으로
              AI가 즉시 답변합니다.
            </Info_Text>
          </Text_div2>
        </>
      ) : (
        <>
          <Image_div2>
            <Image3 src={img_page11_1} alt={img_page11_1} />
          </Image_div2>
          <Image_div2>
            <Image3 src={img_page11_2} alt={img_page11_2} />
          </Image_div2>
          <Text_div2>
            <Info_Text $large $bold>
              관리자
            </Info_Text>
            <Info_Text $gray>
              1) 산업안전보건법, 현장관리 매뉴얼 등 방대한 데이터를 기반으로
              AI가 즉시 답변합니다.
            </Info_Text>
          </Text_div2>
        </>
      )}
    </>
  );
};

export default Platform_SSMS_표준형;
